module.exports = __webpack_public_path__ + "img/loading.3c835903.gif";